// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const greninja: PokeData = {
  "id": 658,
  "name": "greninja",
  "height": 15,
  "weight": 400,
  "base_experience": 239,
  "types": [
    PokeType.WATER,
    PokeType.DARK
  ],
  "api_moves": [
    "pound",
    "growl",
    "water-gun",
    "hydro-pump",
    "quick-attack",
    "double-team",
    "smokescreen",
    "haze",
    "lick",
    "bubble",
    "substitute",
    "feint-attack",
    "spikes",
    "role-play",
    "extrasensory",
    "aerial-ace",
    "water-pulse",
    "night-slash",
    "shadow-sneak",
    "mat-block",
    "water-shuriken"
  ],
  "moves": [
    "growl",
    "hydro-pump",
    "quick-attack",
    "lick",
    "bubble",
    "aerial-ace",
    "night-slash",
    "shadow-sneak",
    "rain-dance",
    "snatch",
    "dark-bargain",
    "bite",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 339,
    "item": null,
    "species": [
      {
        "name": "froakie",
        "order": 657,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "frogadier",
        "order": 658,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 656,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "greninja",
        "order": 659,
        "types": [
          PokeType.WATER,
          PokeType.DARK
        ],
        "evolves_from_species_id": 657,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 95,
    "speed": 165,
    "ability_power": 139
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
